module.exports = __webpack_public_path__ + "img/1518101143.6541bfe9.jpg";